import {
  Box,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useMapa } from "../../../contexts/mapaContext";

const DescriptionBar = ({
  elementSelected = false,
  variant = "default",
  layer = "trafego",
  collapse = true,
  isPing = false,
  severityCounts,
  rangeCounts,
}) => {
  const { config } = useOutletContext();
  const { tipo } = useMapa();
  const [cores, setCores] = useState([]);
  const [unidade, setUnidade] = useState("");
  let theme = useTheme();

  useEffect(() => {
    if (!config) return;
    if (isPing) {
      setCores([
        { cor: "#F44336", label: "DOWN" },
        { cor: "#4CAF50", label: "UP" },
      ]);
      setUnidade("");
    } else if (variant === "default" && layer === "trafego") {
      setCores(config.configuracoes?.[tipo]?.camadaTrafego?.escala);
      setUnidade("%");
    } else if (variant === "default" && layer === "potencia") {
      setCores(config.configuracoes?.[tipo]?.camadaPotencia?.escala);
      setUnidade("");
    } else if (variant === "ftth") {
      setCores(config.configuracoes?.[tipo]?.camadaFTTH?.escala);
      setUnidade("dBm");
    }
  }, [config, layer, tipo, variant, isPing]);

  const styles = {
    textLayer: {
      fontSize: "13px",
      fontWeight: 500,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: 0.5,
      color: theme.palette.layers?.[layer],
      backgroundColor: theme.palette.background.default,
      p: 1,
      width: "fit-content",
      height: "35px",
      transition: "color 0.4s ease", // 👈 animação suave na cor
    },
    borderContainer: {
      borderLeft: !elementSelected
        ? "4px solid " + theme.palette.layers?.[layer]
        : null,
      borderRight: elementSelected
        ? "4px solid " + theme.palette.layers?.[layer]
        : null,
    },
    container: {
      maxHeight: useMediaQuery(theme.breakpoints.up("lg")) ? "35px" : null,
      position: "absolute",
      left: elementSelected ? (collapse ? "0px" : "340px") : null,
      right: elementSelected ? null : 0,
      bottom: 0,
      zIndex: 10,
      alignItems: "end",

      flexDirection: useMediaQuery(theme.breakpoints.up("lg"))
        ? elementSelected
          ? "row-reverse"
          : "row"
        : "colum",
    },
    bar: {
      width: {
        xs: "100vw",
        sm: isPing ? "150px" : "600px",
      },
      p: 0.6,
      backgroundColor: theme.palette.background.default,
      flexDirection: "row",
    },
    box: {
      minHeight: "10px",
      width: "100%",
      ml: "-1px",
    },
  };

  return (
    <>
      <Stack
        sx={{
          ...styles.container,
        }}
      >
        {variant === "default" && (
          <>
            {/* <Stack sx={[styles.textLayer, styles.borderContainer]}>
              {layer === "potencia" && (
                <>
                  <SignalCellularAlt sx={{ fontSize: "19px" }} />
                  {"Camada de Potência"}
                </>
              )}
              {layer === "trafego" && (
                <>
                  <MultipleStop sx={{ fontSize: "19px" }} />
                  {"Camada de Tráfego"}
                </>
              )}
            </Stack> */}
          </>
        )}

        <Stack sx={styles.bar}>
          {cores?.map((cor, index) => (
            <Stack
              key={"barColor" + index}
              direction="row"
              sx={{ justifyContent: "center", height: "25px", width: "100%" }}
            >
              <Divider orientation="vertical" />
              <Stack gap={0.4} width="100%">
                <Box
                  sx={[
                    styles.box,
                    {
                      backgroundColor: cor.cor,
                    },
                  ]}
                />
                <Typography sx={{ fontSize: "10px", ml: "2px" }}>
                  {" "}
                  {cor.label + (index != 0 ? unidade : "")}
                  {isPing && severityCounts && (
                    <span style={{ marginLeft: 4, fontWeight: 700 }}>
                      ({index === 0 ? severityCounts.down : severityCounts.up})
                    </span>
                  )}
                  {!isPing && rangeCounts && (
                    <span style={{ marginLeft: 4, fontWeight: 700 }}>
                      ({rangeCounts[cor.label] ?? 0})
                    </span>
                  )}
                </Typography>
              </Stack>
            </Stack>
          ))}
          <Divider orientation="vertical" sx={{ height: "25px" }} />
        </Stack>
      </Stack>
    </>
  );
};

export default DescriptionBar;
